import React, { useEffect, Fragment, useState } from "react";
import { connect } from "react-redux";
import { bool, func } from "prop-types";
import { push } from "connected-react-router";
import { actions as servicesPaymentActions, selectors as servicesPaymentSelectors } from "reducers/afipPaymentLink";
import Notification from "pages/_components/Notification";
import MainContainer from "pages/_components/MainContainer";
import CustomProductHead from "pages/_components/CustomProductHead";
import ViewTitle from "pages/_components/header/components/ViewTitle";
import Button from "pages/_components/Button";
import ProductList from "pages/_components/product/List";
import GridTable from "pages/_components/GridTable/GridTable";
import AdheredServicesItem from "pages/afipPaymentLink/servicesPayment/linkedService/components/ItemRow";
import TitleColumns from "pages/afipPaymentLink/servicesPayment/linkedService/components/TitleColumns";
import CustomData from "pages/_components/CustomData/CustomData";
import * as i18n from "util/i18n";
import Drawer from "pages/_components/Drawer/Drawer";

const SumaryPage = (props) => {
    const { isDesktop, fetching, dispatch, adheredServicesList } = props;
    const accountsPerBatch = isDesktop ? 10 : 5;
    const [adheredServicesToDisplay, setAdheredServicesToDisplay] = useState([]);
    const [actionDrawer, setActionDrawer] = useState({ showDrawer: false, contentDrawer: null });

    const [fetchingMoreData, setFetchingMoreData] = useState(false);
    const row = isDesktop ? 1 : 4;

    useEffect(() => {
        dispatch(servicesPaymentActions.adheredServicesList());
    }, [dispatch]);

    useEffect(() => {
        if (adheredServicesList?.length) {
            setAdheredServicesToDisplay(adheredServicesList.slice(0, accountsPerBatch));
        }
    }, [adheredServicesList]);

    const hasMoreData = adheredServicesList?.length > adheredServicesToDisplay.length;

    useEffect(() => {
        if (fetching && (adheredServicesList && adheredServicesList.length === 0 || hasMoreData)) {
            setFetchingMoreData(true);
        } else {
            setFetchingMoreData(false);
        }
    }, [fetching]);


    const fetchMoreTransactions = () => {
        const currentLength = adheredServicesToDisplay.length;
        const nextLength = currentLength + accountsPerBatch;
        const newItems = adheredServicesList.slice(0, nextLength);
        setAdheredServicesToDisplay(newItems);
    };

    const handleCloseActionDrawer = () => {
        setActionDrawer({ showDrawer: false, contentDrawer: null, title: "" });
    };

    const renderHeader = () => {
        return (
            <CustomProductHead
                titleId="linkedservices.banner.title"
                backLinkTo="/servicesPayment"
                className="accounts"
                addLinkToLabel="accounts.create.title"
                addLinkTo="/accounts/requestForm"
                exportList="accounts.accountBanner.balances"
                renderMenuOption={null}>
                <div className="toolbar-item view-title">
                    <ViewTitle id="linkedservices.banner.title" />
                </div>
            </CustomProductHead>
        );
    };

    const payScheduledService = (serviceData) => {
        dispatch(servicesPaymentActions.setAddedServicePaymentData(serviceData));
        dispatch(push("/newServicePayment"))
    }

    return (
        <Fragment>
            <Notification scopeToShow="linkAdheredServices" />
            {!fetching && renderHeader()}
            <MainContainer showLoader={fetching}>
                <div className="container">
                    {adheredServicesToDisplay && adheredServicesToDisplay.length > 0 ? (
                        <ProductList
                            fetchingWithPreviousData
                            fetching={fetching && fetchingMoreData}
                            items={adheredServicesToDisplay}
                            noDataText="veps.inProgress.no.results"
                            noFiltersDataText="global.no.results"
                            renderItem={(item) => (
                                <GridTable.Container
                                    key={`payments-item-${item.codigoAdhesion}`}
                                    columns={!isDesktop && 2}
                                    columnsTemplate={isDesktop && "repeat(3, 1fr) 40px"}
                                    className={!isDesktop && "box box-shadow"}>
                                    <AdheredServicesItem
                                        key={`transaction-${item.codigoAdhesion}`}
                                        receivedAdheredService={item}
                                        isDesktop={isDesktop}
                                        setDrawer={setActionDrawer}
                                        payScheduledService={() => payScheduledService(item)}
                                    />
                                </GridTable.Container>
                            )}>
                            {(listItem) => (
                                <GridTable>
                                    {isDesktop && (
                                        <GridTable.Header>
                                            <GridTable.Container rows={row} columnsTemplate="repeat(3, 1fr) 40px">
                                                <TitleColumns />{" "}
                                            </GridTable.Container>
                                        </GridTable.Header>
                                    )}
                                    <GridTable.Body>{listItem}</GridTable.Body>
                                    {hasMoreData && (
                                        <Button
                                            bsStyle="link"
                                            onClick={() => fetchMoreTransactions()}
                                            image="images/figma/icon/arrow.svg"
                                            label="global.showMore"
                                            className="view-more"
                                        />
                                    )}
                                </GridTable>
                            )}
                        </ProductList>
                    ) : (
                        <div className="container--alert" role="alert">
                            <div className="alert alert-info">
                                <CustomData
                                    icon="information_fill.svg"
                                    titleText={i18n.get("linkadheredservices.noregisters")}
                                    keepSpaceIfNoValue={false}
                                />
                            </div>
                        </div>
                    )}
                </div>
                <Drawer openSidebar={actionDrawer.showDrawer} onClose={handleCloseActionDrawer}>
                    {actionDrawer.contentDrawer}
                </Drawer>
            </MainContainer>
        </Fragment>
    );
};

SumaryPage.propTypes = {
    isDesktop: bool,
    dispatch: func.isRequired,
    isMobile: bool,
    fetching: bool,
};

SumaryPage.defaultProps = {
    isDesktop: true,
    isMobile: false,
    fetching: false,
};

const mapStateToProps = (state) => ({
    fetching: servicesPaymentSelectors.getFetching(state),
    adheredServicesList: servicesPaymentSelectors.getAdheredServices(state),
});

export default connect(mapStateToProps)(SumaryPage);
